import React from "react";

function LivePlay() {
    return (
        <span className="icon">
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 60 60"
            >
            <path
                fill="#FFF"
                fillRule="nonzero"
                d="M30 0C13.453 0 0 13.453 0 30s13.453 30 30 30 30-13.453 30-30S46.547 0 30 0zm9.663 31.516l-14.147 9.41c-1.2.821-2.842-.063-2.842-1.515V20.589c0-1.452 1.642-2.336 2.842-1.515l14.147 9.41c1.074.695 1.074 2.337 0 3.032z"
            ></path>
            </svg>
        </span>
    );
}

export default LivePlay;